import { useCallback } from 'react';

import { useDeleteBrandVoice } from 'src/services/useDeleteBrandVoice';
import { useDeleteVisualLanguage } from 'src/services/useDeleteVisualLanguage';
import { useBrandVoicePopup } from 'src/views/BrandVoicePopup';
import { useVisualLanguagePopup } from 'src/views/VisualLanguagePopup';

import { SIDEBAR_ACTION } from '../../lib';
import { useSidebarEvents } from '../../service';
import { useMainActions } from '../../store';

export const useHandlers = () => {
  const { trackNavigationItemClicked } = useSidebarEvents();
  const mainActions = useMainActions();
  const openBrandVoicePopup = useBrandVoicePopup();
  const openVisualLanguagePopup = useVisualLanguagePopup();
  const deleteBrandVoice = useDeleteBrandVoice();
  const deleteVisualLanguage = useDeleteVisualLanguage();

  const handleToggleMenu = useCallback(
    (menuItem) => {
      mainActions.toggleMenuItem(menuItem?.id);
    },
    [mainActions]
  );

  const handleToggleCollapse = useCallback(
    (collapseItem) => {
      mainActions.toggleCollapseItem(collapseItem?.id);
    },
    [mainActions]
  );

  const handleLinkClick = useCallback(
    (linkItem) => {
      trackNavigationItemClicked({ label: linkItem.label });

      if (!linkItem.isChildItem && !linkItem.disableNavigation) {
        mainActions.collapseAll();
      }
    },
    [mainActions, trackNavigationItemClicked]
  );

  const handleSidebarAction = useCallback(
    (type, data) => {
      switch (type) {
        case SIDEBAR_ACTION.createBrandVoice: {
          openBrandVoicePopup();
          break;
        }

        case SIDEBAR_ACTION.editBrandVoice: {
          openBrandVoicePopup({ brandVoice: data });
          break;
        }

        case SIDEBAR_ACTION.deleteBrandVoice: {
          deleteBrandVoice(data.id, data.name);
          break;
        }

        case SIDEBAR_ACTION.createVisualLanguage: {
          openVisualLanguagePopup();
          break;
        }

        case SIDEBAR_ACTION.editVisualLanguage: {
          openVisualLanguagePopup({ visualLanguage: data });
          break;
        }

        case SIDEBAR_ACTION.deleteVisualLanguage: {
          deleteVisualLanguage(data);
          break;
        }

        default: {
          // do nothing
        }
      }
    },
    [openBrandVoicePopup, deleteBrandVoice, openVisualLanguagePopup, deleteVisualLanguage]
  );

  return {
    handleToggleMenu,
    handleToggleCollapse,
    handleLinkClick,
    handleSidebarAction,
  };
};
